import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Accordion} from 'react-bootstrap';
 
 
// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import servicesPic1 from "../../images/services/pic5.jpg";
import videoBackground from "../../images/video-background.png";
 

import '../../scss/player.css'
 
class ServiceCT extends Component{
	
	render(){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Funduplicatura</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><a href="index.html"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Inicio</a></li>
											<li className="breadcrumb-item active" aria-current="page">Funduplicatura</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-8 mb-30">
									<div className="ttr-media mb-30">
										<img src={servicesPic1} className="rounded" alt=""/>
									</div>
									<div className="clearfix col-lg-12">
										<div className="head-text mb-30">
											<h2 className="title mb-15">¿Qué es una Funduplicatura Laparoscópica? </h2>
											<p className="mb-0">La fundoplicatura tipo Nissen por vía laparoscópica (FNL) es la técnica de elección en el tratamiento quirúrgico, de la enfermedad por reflujo gastroesofágico (ERGE). Sus buenos resultados ha llevado a que muchos pacientes y médicos, prefieran la cirugía a seguir de por vida con tratamiento médico. Consiste en hacer una pequeña incisión entre el esófago y el estómago e introducir por ahí el laparoscopio, que es una cámara de mínimas dimensiones para evaluar y corregir anomalías en el esfínter o válvula del tracto digestivo que impide que los alimentos y los ácidos gástricos se regresen por el esófago. Esta técnica quirúrgica, al ser de mínima invasión, ofrece al paciente mejores resultados, menor dolor y una pronta recuperación. En ella se utiliza anestesia general. </p>
										</div>
										<p className="mb-0">A continuación, podrá ver un video explicativo al respecto.</p>
										<a rel="noreferrer" href="https://www.youtube.com/watch?v=Euf5pQHI5rY" target="_blank">
										<img src={videoBackground} className="rounded" alt=""/>
										</a>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h4 className="title mb-10">Preguntas al respecto</h4>
 										</div>
										<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
											<Accordion.Item eventKey="0">
												<Accordion.Header>¿Cuáles son las ventajas de la cirugía laparoscópica?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">En comparación con la cirugía tradicional abierta, los pacientes sienten menos dolor, tienen un período de recuperación más breve y hay menos cicatrización con la cirugía laparoscópica.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="1">
												<Accordion.Header>¿Qué tipo de operaciones puede realizarse con la cirugía laparoscópica?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">La mayoría de las cirugías intestinales puede realizarse con la técnica laparoscópica. Éstas incluyen la cirugía para la enfermedad de Crohn, colitis ulcerosa, diverticulitis, cáncer, prolapso rectal y estreñimiento grave. Anteriormente, había preocupación por la seguridad de la cirugía laparoscópica en las operaciones de cáncer. En la actualidad, varios estudios en los que participaron cientos de pacientes han demostrado que la cirugía laparoscópica es segura para ciertos cánceres colorrectales.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="2">
												<Accordion.Header>¿Qué tan segura es la cirugía laparoscópica?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">La cirugía laparoscópica es tan segura como la cirugía tradicional abierta. Al iniciar una operación laparoscópica, se inserta el laparoscopio a través de una incisión pequeña y cercana al ombligo. El cirujano inspecciona primero el abdomen para determinar si es seguro realizar una cirugía laparoscópica. Si hay una gran inflamación, o si el cirujano encuentra otros factores que impiden ver claramente las estructuras, puede tener que hacer una incisión más grande para terminar la operación de manera segura. Toda cirugía intestinal implica un cierto riesgo, tal como complicaciones relacionadas con la anestesia y hemorragias o complicaciones de infección. El riesgo de toda operación lo determina en parte la naturaleza de la operación específica. La salud general de la persona y otros problemas médicos también son factores que afectan el riesgo de cualquier operación. Usted debe hablar con el cirujano acerca de su riesgo en particular para alguna operación.</p>
												</Accordion.Body>
											</Accordion.Item>
											 
										</Accordion>
									</div>
								</div>
								<div className="col-lg-4">
									<aside className="sticky-top pb-1">
										<div className="widget">
											<ul className="service-menu">
												<li className="active"><Link to="/service_ct"><span>Colecistectomía Laparoscópica</span><i className="fa fa-angle-right"></i></Link></li>
												<li><Link to="/service_erge"><span>Hernia Hiatal</span><i className="fa fa-angle-right"></i></Link></li> 
											</ul>
										</div>
									</aside>
								</div>
							</div>
						</div>
					</section>
					
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default ServiceCT;